<template>
  <div :class="cardClass">
    <span
      v-if="tier === 'pro'"
      :class="$style.popular + ' h6 w-60 mx-auto px-2 py-1 rounded-bottom text-white shadow-sm'"
    >
      MOST POPULAR
    </span>
    <div class="bg-transparent card-header px-2 mt-3 pt-3 border-0">
      <div :class="$style.tier">{{ cap(tier) }}</div>
      <div class="border-bottom pb-3">
        <price
          :tier="tier"
          :term="term"
          :currency="currency"
          :prices="prices"
        />
      </div>
    </div>
    <div class="card-body px-2 pt-0">
      <ul :class="$style.features + ' list-unstyled mb-4'">
        <li v-for="feature in goodFeatures[tier]" :key="feature">
          <i :class="$style.listicon + ' fe fe-check mr-0'" />
          {{ feature }}
        </li>
        <li v-for="feature in badFeatures[tier]" :key="feature">
          <i :class="$style.listicon2 + ' fe fe-x mr-0'" />
          {{ feature }}
        </li>
      </ul>
      <div class="row mb-2 justify-content-center" v-if="tier != 'basic'">
        <a-button
          type="success"
          :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
          :loading="btnCardLoading"
          @click="checkout"
        >
          <strong>Pay by Card</strong>
        </a-button>
      </div>
      <div class="row justify-content-center" v-if="currency === 'php' && tier != 'basic'">
        <a-button
          type="primary"
          :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
          :loading="btnGcashLoading"
          @click="openGcash"
        >
          <strong>Pay via GCash*</strong>
        </a-button>
      </div>
      <div class="row justify-content-center" v-if="tier === 'basic'">
        <a-button
          type="primary"
          :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
          @click="$router.push('/dashboard/alpha')"
        >
          <strong>Access Now</strong>
        </a-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<script>
import price from '../price'

export default {
  props: ['term', 'tier', 'currency', 'goodFeatures', 'badFeatures', 'prices', 'disableButtons'],
  components: {
    price,
  },
  data() {
    return {
      pricingIcon: 'fe fe-inbox font-size-40 mb-3 d-block',
      btnCardLoading: false,
      btnGcashLoading: false,
    }
  },
  methods: {
    cap(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    checkout() {
      this.btnCardLoading = true
      this.$emit('checkout', this.tier, this.term, this.currency)
      console.log('Checkout initiates: ' + this.tier + this.term + this.currency)
    },
    openGcash() {
      // this.btnGcashLoading = true
      this.$emit('openGcash', this.tier, this.term, this.currency)
      console.log('GCash initiated: ' + this.tier + this.term + this.currency)
    },
  },
  computed: {
    cardClass() {
      if (this.tier === 'pro') {
        return this.$style.newcardpro + ' card shadow text-center px-2 mb-4 mx-auto'
      } else {
        return this.$style.newcard + ' card shadow text-center px-2 mb-4 mx-auto'
      }
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>
